module.exports = __webpack_public_path__ + "images/psp/amenities/paved-surfaces.svg";